// extracted by mini-css-extract-plugin
module.exports = {"singInWrapperMob":"signUpBlock_singInWrapperMob__VQDPr","singInWrapper":"signUpBlock_singInWrapper__3Fhrs"};